module.exports = __webpack_public_path__ + "asset/image-iconCategoryCar-4b0b7dd9ad22a98e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/iconCategoryCar.svg
// module id = pdTe
// module chunks = 0